function cookieModal () {
    const validateCookie = (status = false) => {
        console.log(document.cookie.indexOf("klaro"))

        if (document.cookie.indexOf("klaro") === -1) return;

        const klaro_reset = "klaro=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        const klaro_custom = "custom_clear=true; path=/;";

        if (document.cookie.indexOf("custom_clear") === -1 || status) {
            document.cookie = klaro_reset;
            document.cookie = klaro_custom;
        }
    }

    // validateCookie();

    var modal = document.querySelector('.cookie-notice');
    
    document.body.addEventListener('click', function(event) {
      
      if (modal && (!modal.contains(event.target) && !event.target.closest('.hide'))) {
        var acceptButton = document.querySelector('.cn-buttons .cm-btn-success');
        acceptButton && acceptButton.click();
      }
    });

    const content = $(".cookie-notice");
    const contentModal = $(".cookie-notice .cn-learn-more");
    const contentDecline = $(".cookie-notice .cn-decline");
    const success = $(".cookie-notice .cm-btn-success");
    if (content && content.length) {
        dataLayer.push({
            'event': 'klaro_view_general'
        })
    }

    if (contentModal && contentModal.length) {
        $(".cookie-notice .cn-learn-more").on("click", () => {
            dataLayer.push({
                'event': 'klaro_view_cookiesOptions'
            });

            const acceptAll = $(".cm-btn-accept-all");
            if (acceptAll && acceptAll.length) {
                $(".cm-btn-accept-all").on("click", () => {
                    dataLayer.push({
                        'event': 'klaro_consentChoice'
                    })
                })
            }

            const accept = $(".cm-btn-accept");
            if (accept && accept.length) {
                $(".cm-btn-accept").on("click", () => {
                    dataLayer.push({
                        'event': 'klaro_consentChoice'
                    })
                })
            }
        })
    }

    if (contentDecline && contentDecline.length) {
        $(".cookie-notice .cn-decline").on("click", () => {
            dataLayer.push({
                'event': 'klaro_reject_all'
            })
        })
    }

    if (success && success.length) {
        $(".cookie-notice .cm-btn-success").on("click", () => {
            dataLayer.push({
                'event': 'klaro_consentChoice'
            })
        })
    }
}

// Simulate click agree Custom Code
 document.addEventListener('DOMContentLoaded', function() {
    cookieModal();
  });

// Config Klaro

    // By default, Klaro will load the config from  a global "klaroConfig" variable.
// You can change this by specifying the "data-config" attribute on your
// script take, e.g. like this:
// <script src="klaro.js" data-config="myConfigVariableName" />
var klaroConfig = {
    // With the 0.7.0 release we introduce a 'version' paramter that will make
    // it easier for us to keep configuration files backwards-compatible in the future.
    version: 1,

    // You can customize the ID of the DIV element that Klaro will create
    // when starting up. If undefined, Klaro will use 'klaro'.
    elementID: 'klaro',

    // You can override CSS style variables here. For IE11, Klaro will
    // dynamically inject the variables into the CSS. If you still consider
    // supporting IE9-10 (which you probably shouldn't) you need to use Klaro
    // with an external stylesheet as the dynamic replacement won't work there.
    styling: {
        theme: ['light', 'bottom', 'wide' ],
        
    },

    // Setting this to true will keep Klaro from automatically loading itself
    // when the page is being loaded.
    noAutoLoad: false,

    // Setting this to true will render the descriptions of the consent
    // modal and consent notice are HTML. Use with care.
    htmlTexts: true,

    // Setting 'embedded' to true will render the Klaro modal and notice without
    // the modal background, allowing you to e.g. embed them into a specific element
    // of your website, such as your privacy notice.
    embedded: false,

    // You can group services by their purpose in the modal. This is advisable
    // if you have a large number of services. Users can then enable or disable
    // entire groups of services instead of having to enable or disable every service.
    groupByPurpose: false,

    // How Klaro should store the user's preferences. It can be either 'cookie'
    // (the default) or 'localStorage'.
    storageMethod: 'cookie',

    // You can customize the name of the cookie that Klaro uses for storing
    // user consent decisions. If undefined, Klaro will use 'klaro'.
    cookieName: 'klaro',

    // You can also set a custom expiration time for the Klaro cookie.
    // By default, it will expire after 120 days.
    cookieExpiresAfterDays: 365,

    // You can change to cookie domain for the consent manager itself.
    // Use this if you want to get consent once for multiple matching domains.
    // If undefined, Klaro will use the current domain.
    //cookieDomain: '.github.com',

    // You can change to cookie path for the consent manager itself.
    // Use this to restrict the cookie visibility to a specific path.
    // If undefined, Klaro will use '/' as cookie path.
    //cookiePath: '/',

    // Defines the default state for services (true=enabled by default).
    default: true,

    // If "mustConsent" is set to true, Klaro will directly display the consent
    // manager modal and not allow the user to close it before having actively
    // consented or declines the use of third-party services.
    mustConsent: false,

    // Show "accept all" to accept all services instead of "ok" that only accepts
    // required and "default: true" services
    acceptAll: true,

    // replace "decline" with cookie manager modal
    hideDeclineAll: false,

    // hide "learnMore" link
    hideLearnMore: false,

    // show cookie notice as modal
    noticeAsModal: false,

    // You can also remove the 'Realized with Klaro!' text in the consent modal.
    // Please don't do this! We provide Klaro as a free open source tool.
    // Placing a link to our website helps us spread the word about it,
    // which ultimately enables us to make Klaro! better for everyone.
    // So please be fair and keep the link enabled. Thanks :)
    //disablePoweredBy: true,

    // you can specify an additional class (or classes) that will be added to the Klaro `div`
    //additionalClass: 'my-klaro',

    // You can define the UI language directly here. If undefined, Klaro will
    // use the value given in the global "lang" variable. If that does
    // not exist, it will use the value given in the "lang" attribute of your
    // HTML tag. If that also doesn't exist, it will use 'en'.
    //lang: 'en',

    // You can overwrite existing translations and add translations for your
    // service descriptions and purposes. See `src/translations/` for a full
    // list of translations that can be overwritten:
    // https://github.com/KIProtect/klaro/tree/master/src/translations

    // Example config that shows how to overwrite translations:
    // https://github.com/KIProtect/klaro/blob/master/src/configs/i18n.js
    translations: {
        // translationsed defined under the 'zz' language code act as default
        // translations.
        zz: {
            privacyPolicyUrl: '/#privacy',
        },
        // If you erase the "consentModal" translations, Klaro will use the
        // bundled translations.
        de: {
            privacyPolicyUrl: '/#datenschutz',
            consentModal: {
                description:
                    'Hier können Sie einsehen und anpassen, welche Information wir über Sie sammeln. Einträge die als "Beispiel" gekennzeichnet sind dienen lediglich zu Demonstrationszwecken und werden nicht wirklich verwendet.',
            },
            inlineTracker: {
                description: 'Beispiel für ein Inline-Tracking Skript',
            },
            externalTracker: {
                description: 'Beispiel für ein externes Tracking Skript',
            },
            adsense: {
                description: 'Anzeigen von Werbeanzeigen (Beispiel)',
                title: 'Google AdSense Werbezeugs',
            },
            matomo: {
                description: 'Sammeln von Besucherstatistiken',
            },
            camera: {
                description:
                    'Eine Überwachungskamera (nur ein Beispiel zu IMG-Tags)',
            },
            cloudflare: {
                description: 'Schutz gegen DDoS-Angriffe',
            },
            intercom: {
                description:
                    'Chat Widget & Sammeln von Besucherstatistiken (nur ein Beispiel)',
            },
            mouseflow: {
                description: 'Echtzeit-Benutzeranalyse (nur ein Beispiel)',
            },
            googleFonts: {
                description: 'Web-Schriftarten von Google gehostet',
            },
            purposes: {
                analytics: 'Besucher-Statistiken',
                security: 'Sicherheit',
                livechat: 'Live Chat',
                advertising: 'Anzeigen von Werbung',
                styling: 'Styling',
            },
        },
       
        en: {
            consentModal: {
                title: '<u>test</u>',
                description:
                    'Here you can see and customize the information that we collect about you. Entries marked as "Example" are just for demonstration purposes and are not really used on this website.',
            },
            inlineTracker: {
                description: 'Example of an inline tracking script',
            },
            externalTracker: {
                description: 'Example of an external tracking script',
            },
            adsense: {
                description: 'Displaying of advertisements (just an example)',
                title: 'Google Adsense Advertisement',
            },
            matomo: {
                description: 'Collecting of visitor statistics',
            },
            camera: {
                description:
                    'A surveillance camera (just an example for an IMG tag)',
            },
            cloudflare: {
                description: 'Protection against DDoS attacks',
            },
            intercom: {
                description:
                    'Chat widget & collecting of visitor statistics (just an example)',
            },
            mouseflow: {
                description: 'Real-Time user analytics (just an example)',
            },
            googleFonts: {
                description: 'Web fonts hosted by Google',
            },
            purposes: {
                analytics: 'Analytics',
                security: 'Security',
                livechat: 'Livechat',
                advertising: 'Advertising',
                styling: 'Styling',
            },
        },

        es: {
            acceptSelected: "Confirmar Seleccionadas",
            consentNotice: {
                description: 'Las cookies son importantes para el correcto funcionamiento de un sitio. Para mejorar tu experiencia, utilizamos cookies para recordar los detalles proporcionar un inicio de sesión seguro, recopilar estadísticas para optimizar la funcionalidad del sitio y ofrecer contenido personalizado a tus intereses. Tu clic en "Aceptar y continuar" aceptas todas estas cookies según se describe en nuestro Aviso de cookies. Para cambiar tu consentimiento, haz clic en "Ajustar consentimiento".',
                learnMore: "Ajustar Consentimiento"
            },
            consentModal: {
                title: "Centro de Preferencias de Privacidad",
                description: "Tienes la opción de ajustar tu consentimiento de cookies. Ajusta la configuración por categoría de acuerdo con tus preferencias de consentimiento. Ten en cuenta que tu ajuste puede tener un impacto en tu experiencia en nuestro sitio. Para obtener más información sobre qué cookies específicas se encuentran en cada categoría, consulta nuestra declaración de consentimiento de cookies",
            },
            ok: "Aceptar y Continuar",
            decline: "Rechazar Todo",
            privacyPolicy: {
                name: "aquí",
                text: "{privacyPolicy}"
            }
        }
    },

    // This is a list of third-party services that Klaro will manage for you.
    services: [
        {
            name: 'Analytical & Performance Cookies',
            description: "Estas cookies nos permiten contar las visitas y fuentes de tráfico para que podamos medir y mejorar el rendimiento de nuestro sitio. Nos ayudan a saber cuáles son las páginas más y menos populares y a ver cómo los visitantes se mueven por el sitio. Toda la información que recopilan estas cookies es anónima. Si no permite estas cookies, no sabremos cuándo ha visitado nuestro sitio y no podremos controlar su rendimiento."
            // if you omit the title here Klaro will try to look it up in the
            // translations
            // title: 'Google AdSense',
            // purposes: ['Analytical & Performance Cookies'],
        },   
        {
            name: 'Advertising & Social Media Cookies',
            description: "Estas cookies son establecidas por una serie de servicios de redes sociales que hemos agregado al sitio para permitirte compartir nuestro contenido con tus amigos y redes. Son capaces de rastrear tu navegador en otros sitios y crear un perfil de tus intereses. Esto puede afectar el contenido y los mensajes que ves en otros sitios web que visitas. Si no permites estas cookies, es posible que no puedas usar o ver estas herramientas de compartir."
            // if you omit the title here Klaro will try to look it up in the
            // translations
            //title: 'Google AdSense',
            // purposes: ['Advertising & Social Media Cookies'],
        },
        {
            name: 'Cookies estrictamente necesarias',
            title: 'Cookies estrictamente necesarias',
            description: "Estas cookies son necesarias para que el sitio web funcione y no se pueden desactivar en nuestros sistemas. Por lo general, solo se configuran en respuesta a acciones realizadas por ti que equivalen a una solicitud de servicios, como configurar tus preferencias de privacidad, iniciar sesión o completar formularios. Puedes configurar tu navegador para bloquear o alertarte sobre estas cookies, pero algunas partes del sitio no funcionarán en ese caso. Estas cookies no almacenan información personal identificable.",
            // if you omit the title here Klaro will try to look it up in the
            // translations
            //title: 'Google AdSense',
            default: true,
            purposes: ['Cookies estrictamente necesarias'],
        }
/*        {
            name: 'googleFonts',
            title: 'Google Fonts',
            purposes: ['styling'],
        },*/

    ],
};